<template>
  <div class="min-h-screen p-8">
    <div class="w-full">
      <input v-model="query" @input="fetchAllProducts()" placeholder="Search by name, description and code" type="text" class="search h-12 px-4 rounded border border-gray-600 w-1/3">
      <button class="border-2 border-gray-600 font-bold text-sm text-gray-600 ml-4 py-2 px-4 rounded float-right" @click="openBulkDiscountModal()">Bulk Discount</button>
      <el-dropdown class="float-right" @command="handleCommand">
      <span class="el-dropdown-link">
       <button class="border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded">
          New Product
       </button>
      </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="csv">CSV Upload</el-dropdown-item>
          <el-dropdown-item command="manual">Manual Creation</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class=""
         v-loading="loading"
         element-loading-text="Loading..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="mt-4">
        <el-table
          :data="products"
          :empty-text="'No Category available'"
          :default-sort="{prop: 'id', order: 'ascending'}"
          style="width: 100%">
          <el-table-column>
            <template slot="header">
              <span>Name</span>
              <TableHeaderFilter @fetchData="fetchAllProducts" commit-path="InventoryModule/Products/setProperty" name="name" :store-path="{module: 'InventoryModule', subModule: 'Products'}"/>
            </template>
            <template slot-scope="scope">
              <span>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="code"
            label="Code">
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <span>Cost Price</span>
              <TableHeaderFilter @fetchData="fetchAllProducts" commit-path="InventoryModule/Products/setProperty" name="cost" :store-path="{module: 'InventoryModule', subModule: 'Products'}"/>
            </template>
            <template slot-scope="scope">{{ priceFormat(scope.row.cost) }}</template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <span>Selling Price</span>
              <TableHeaderFilter @fetchData="fetchAllProducts" commit-path="InventoryModule/Products/setProperty" name="price" :store-path="{module: 'InventoryModule', subModule: 'Products'}"/>
            </template>
            <template slot-scope="scope">{{ priceFormat(scope.row.price) }}</template>
          </el-table-column>
          <el-table-column
            prop="discount"
            align="center"
            label="Discount (%)">
          </el-table-column>
          <el-table-column
            prop="image"
            label="Image Link">
            <template slot-scope="scope">
              <a class="text-xs text-blue-500 italic hover:underline cat-img" v-if="scope.row.image" :href="scope.row.image" target="_blank">
                <img width="50" height="50" :src=scope.row.image>
              </a>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            label="">
            <template slot-scope="scope">
              <el-button @click="update(scope.row.slug, scope.row.id)" type="text" size="small">
                <i class="text-sm el-icon-edit mr-1"></i>
              </el-button>
              <el-button @click="uploadImage(scope.row.slug)" type="text" size="small">
                <i class="text-sm el-icon-picture mr-1"></i>
              </el-button>
              <el-button @click="deleteProduct(scope.row.id)" type="text" size="small">
                <i class="text-sm text-red-500 el-icon-delete-solid"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt-8 mb-8 float-right"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-size="pagination.perPage"
          :page-count="pagination.lastPage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
        <BulkDiscountForm v-on:modalClosed="fetchAllProducts"/>
      </div>

    </div>
  </div>
</template>

<script>
import BulkDiscountForm from './_includes/Forms/BulkDiscountForm.vue';
import TableHeaderFilter from '../../../../../Common/components/TableHeaderFilter.vue';

export default {
  name: 'Products',
  data() {
    return {
      page: 1,
      limit: 20,
      loading: false,
    };
  },
  components: {
    BulkDiscountForm,
    TableHeaderFilter,
  },
  computed: {
    products() {
      return this.$store.state.InventoryModule.Products.products || [];
    },
    pagination() {
      return this.$store.state.InventoryModule.Products.pagination;
    },
    query: {
      get() {
        return this.$store.state.InventoryModule.Products.query;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProperty', { property: 'query', payload: value });
      },
    },
  },
  methods: {
    openBulkDiscountModal() {
      this.$modal.show('bulk-discount-modal');
    },
    handleCommand(command) {
      const routeData = this.$router.resolve({ name: 'csv-upload' });

      switch (command) {
        case 'manual':
          this.$router.push('/ecommerce/inventory/products/new');
          break;
        case 'csv':
          window.open(routeData.href, '_blank');
          break;
        default:
          break;
      }
    },
    deleteProduct(productId) {
      this.$confirm('This will permanently delete this products, and all it data. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(async () => {
          try {
            await this.$store.dispatch('InventoryModule/Products/deleteProduct', { productId });
            this.$notify.success({
              title: 'Success',
              message: 'Product successfully deleted',
            });
          } catch (e) {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong please try again.',
            });
          }
        });
    },
    update(slug, id) {
      this.$router.push(`/ecommerce/inventory/products/${slug}/edit?id=${id}`);
    },
    uploadImage(slug) {
      this.$router.push(`/ecommerce/inventory/products/${slug}/image-upload`);
    },
    handleSizeChange(args) {
      this.limit = args;
      this.fetchAllProducts();
    },
    handleCurrentChange(args) {
      this.page = args;
      this.fetchAllProducts();
    },
    async fetchAllProducts() {
      this.loading = true;
      try {
        await this.$store.dispatch('InventoryModule/Products/fetchAllProducts', {
          page: this.page,
          limit: this.limit,
          query: this.query,
        });
      } catch (e) {
        // Handle This TODO
      }

      this.loading = false;
    },
  },


  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    await this.fetchAllProducts();
  },
};
</script>

<style scoped lang="scss">
  .search {
    outline: none;
  }
</style>
